import { type MCPServerInfo } from '../../types';

const MiroOfficialServer: MCPServerInfo = {
  serverId: 'MIRO_OFFICIAL',
  name: 'Miro',
  slug: 'miro-official',
  description:
    "Miro's official remote MCP server. Read and write boards, items, diagrams, docs, images, and tables through the Miro MCP API. Admins must enable MCP Server in Miro org settings before users can connect.",
  source: {
    sourceType: 'REMOTE_URL',
    mcpServerUrl: 'https://mcp.miro.com/'
  },
  authenticationType: 'OAUTH',
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: [],
    properties: {}
  }
};

export default MiroOfficialServer;
